var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustpilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 251 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "trustpilot_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas",
    fill: "#dcdce6",
    d: "M0 46.33h46.376V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__shape",
    d: "M39.534 19.711L13.23 38.801l3.838-11.798L7.021 19.71h12.42l3.837-11.798 3.837 11.798h12.419zm-16.255 11.8L30.462 30l2.862 8.8-10.045-7.29z",
    fill: "#FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "trustpilot_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas",
    fill: "#dcdce6",
    d: "M51.248 46.33h46.376V0H51.248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas--half",
    fill: "#dcdce6",
    d: "M51.248 46.33h23.188V0H51.248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__shape",
    d: "M74.991 31.33l6.16-1.33L84 39l-9.66-7.203L64.303 39l3.895-11.84L58 19.84h12.606L74.5 8l3.895 11.841H91L74.991 31.33z",
    fill: "#FFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "trustpilot_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas",
    fill: "#dcdce6",
    d: "M102.532 46.33h46.376V0h-46.376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas--half",
    fill: "#dcdce6",
    d: "M102.532 46.33h23.188V0h-23.188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__shape",
    d: "M142.067 19.711l-26.304 19.09 3.839-11.798-10.048-7.292h12.42l3.837-11.798 3.837 11.798h12.419zm-16.255 11.8l7.183-1.51 2.862 8.8-10.045-7.29z",
    fill: "#FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "trustpilot_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas",
    fill: "#dcdce6",
    d: "M153.815 46.33h46.376V0h-46.376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas--half",
    fill: "#dcdce6",
    d: "M153.815 46.33h23.188V0h-23.188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__shape",
    d: "M193.348 19.711l-26.303 19.09 3.838-11.798-10.047-7.292h12.419l3.837-11.798 3.837 11.798h12.42zm-16.255 11.8l7.184-1.51 2.862 8.8-10.046-7.29z",
    fill: "#FFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "trustpilot_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas",
    fill: "#dcdce6",
    d: "M205.064 46.33h46.376V0h-46.376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__canvas--half",
    fill: "#dcdce6",
    d: "M205.064 46.33h23.188V0h-23.188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trustpilot_svg__tp-star__shape",
    d: "M244.597 19.711l-26.303 19.09 3.838-11.798-10.048-7.292h12.42l3.837-11.798 3.837 11.798h12.419zm-16.255 11.8l7.183-1.51 2.862 8.8-10.045-7.29z",
    fill: "#FFF"
  }))));
}
export default SvgTrustpilot;